const mapsSearch = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

const photo = {
  town: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?auto=format&fit=crop&w=900&q=70",
  art: "https://images.unsplash.com/photo-1577083552431-6e5fd01aa342?auto=format&fit=crop&w=900&q=70",
  creative: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?auto=format&fit=crop&w=900&q=70",
  village: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=900&q=70",
  river: "https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=900&q=70",
  headland: "https://images.unsplash.com/photo-1471922694854-ff1b63b20054?auto=format&fit=crop&w=900&q=70",
  coast: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=900&q=70",
  lake: "https://images.unsplash.com/photo-1439066615861-d1af74d74000?auto=format&fit=crop&w=900&q=70",
  farm: "https://images.unsplash.com/photo-1464226184884-fa280b87c399?auto=format&fit=crop&w=900&q=70",
  wildlife: "https://images.unsplash.com/photo-1564349683136-77e08dba1ef7?auto=format&fit=crop&w=900&q=70",
  birds: "https://images.unsplash.com/photo-1444464666168-49d633b86797?auto=format&fit=crop&w=900&q=70",
  rockpool: "https://images.unsplash.com/photo-1432405972618-c60b0225b8f9?auto=format&fit=crop&w=900&q=70",
  rainforest: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=900&q=70",
  falls: "https://images.unsplash.com/photo-1546182990-dffeafbe841d?auto=format&fit=crop&w=900&q=70",
  mountain: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=900&q=70",
  beach: "https://images.unsplash.com/photo-1519046904884-53103b34b206?auto=format&fit=crop&w=900&q=70",
  surf: "https://images.unsplash.com/photo-1502680390469-be75c86b636f?auto=format&fit=crop&w=900&q=70",
  walk: "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?auto=format&fit=crop&w=900&q=70",
  skyline: "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?auto=format&fit=crop&w=900&q=70",
  golf: "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?auto=format&fit=crop&w=900&q=70",
  city: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?auto=format&fit=crop&w=900&q=70",
  hinterland: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=70",
  pool: "https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?auto=format&fit=crop&w=900&q=70",
  fitness: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=900&q=70",
  spa: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?auto=format&fit=crop&w=900&q=70",
};

const place = (
  name,
  type,
  description,
  address,
  image,
  mapsLabel = "View on Google Maps",
  mapsQuery
) => ({
  id: name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, ""),
  name,
  type,
  description,
  address,
  image,
  mapsHref: mapsSearch(mapsQuery || address),
  mapsLabel,
});

export const experienceSections = [
  {
    id: "Tweed Heads South, NSW-tweed-valley",
    title: "Tweed Heads South, NSW & Tweed Valley",
    places: [
      place(
        "Tweed Heads South, NSW Town Centre",
        "Local Town, Cafés & Shopping",
        "Discover the heart of Tweed Heads South, NSW with local cafés, restaurants, shops, galleries and historic streets. It is a convenient place to explore when staying at Arabella Motor Inn.",
        "Tweed Heads South, NSW 2484",
        photo.town
      ),
      place(
        "Tweed Regional Gallery & Margaret Olley Art Centre",
        "Art & Culture",
        "Explore Australian art, exhibitions and local culture at this regional gallery in Tweed Heads South, NSW. A great option for guests looking for cultural things to do near Tweed Heads South, NSW.",
        "Mistral Road, Tweed Heads South, NSW 2484",
        photo.art
      ),
      place(
        "M-Arts Precinct",
        "Arts & Creative Experiences",
        "Discover local creativity, art, food and community culture in the M-Arts Precinct in Tweed Heads South, NSW.",
        "4 Brisbane Street, Tweed Heads South, NSW 2484",
        photo.creative
      ),
      place(
        "Tumbulgum",
        "Riverside Village",
        "Visit the peaceful village of Tumbulgum, located around the meeting point of the Tweed and Rous Rivers. Enjoy the relaxed atmosphere and surrounding scenery.",
        "Tumbulgum, NSW 2486",
        photo.village
      ),
    ],
  },
  {
    id: "tweed-heads-coast",
    title: "Tweed Heads & Tweed Coast",
    places: [
      place(
        "Tweed Heads",
        "Coastal Town & River Experiences",
        "Explore Tweed Heads with its waterfront areas, river scenery, cafés and easy access to nearby beaches and coastal attractions.",
        "Tweed Heads, NSW 2485",
        "/images/Tweed Heads.png"
      ),
      place(
        "Point Danger",
        "Coastal Views & Border Experience",
        "Visit Point Danger for spectacular coastal scenery around the NSW–Queensland border. It is a great addition to a day exploring Tweed Heads and Coolangatta.",
        "Point Danger, Tweed Heads NSW 2485",
        "/images/Duranbah Beach.png"
      ),
      place(
        "Fingal Head",
        "Coastal Nature",
        "Explore the beautiful coastline around Fingal Head, with scenic walking areas and natural coastal landscapes.",
        "Fingal Head, NSW 2487",
        photo.coast
      ),
      place(
        "Cudgen Lake",
        "Lake & Outdoor Recreation",
        "Enjoy the peaceful surroundings of Cudgen Lake near the Tweed Coast. It is a relaxing destination for visitors wanting to experience the area's natural environment.",
        "Cudgen, NSW 2487",
        photo.lake
      ),
    ],
  },
  {
    id: "wildlife-family",
    title: "Wildlife & Family Attractions",
    places: [
      place(
        "Tropical Fruit World",
        "Farm & Family Experience",
        "Enjoy tropical gardens, farm experiences and family-friendly activities at this popular Tweed Coast attraction.",
        "29 Duranbah Road, Duranbah NSW 2486",
        photo.farm
      ),
      place(
        "Currumbin Wildlife Sanctuary",
        "Australian Wildlife",
        "Meet Australian wildlife and discover family-friendly experiences at one of the region's well-known wildlife attractions.",
        "28 Tomewin Street, Currumbin QLD 4223",
        photo.wildlife
      ),
      place(
        "David Fleay Wildlife Park",
        "Wildlife & Conservation",
        "Discover native Australian wildlife and enjoy an educational family experience at David Fleay Wildlife Park.",
        "Loman Lane, Burleigh Heads QLD 4220",
        photo.birds
      ),
      place(
        "Currumbin Rock Pools",
        "Swimming & Family Adventure",
        "Enjoy a natural outdoor experience in Currumbin Valley, surrounded by rainforest and scenic landscapes.",
        "Currumbin Valley, QLD 4223",
        photo.rockpool
      ),
    ],
  },
  {
    id: "nature-parks",
    title: "Nature & National Parks",
    places: [
      place(
        "Springbrook National Park",
        "Rainforest & Scenic Views",
        "Explore rainforest, waterfalls, walking trails and spectacular mountain scenery in the Gold Coast hinterland.",
        "Springbrook, QLD 4213",
        photo.rainforest
      ),
      place(
        "Lamington National Park",
        "Rainforest & Wildlife",
        "Discover ancient rainforest, walking trails, wildlife and mountain scenery in this beautiful national park.",
        "Lamington National Park, QLD 4275",
        photo.rainforest
      ),
      place(
        "Border Ranges National Park",
        "Mountains & Scenic Landscapes",
        "Experience spectacular mountain and rainforest scenery across the Border Ranges region.",
        "Border Ranges National Park, NSW",
        photo.mountain
      ),
      place(
        "Mount Jerusalem National Park",
        "Rainforest & Wilderness",
        "Explore the natural landscapes and rainforest environment of Mount Jerusalem National Park in the Northern Rivers.",
        "Mount Jerusalem National Park, NSW",
        photo.rainforest
      ),
    ],
  },
  {
    id: "gold-coast",
    title: "Gold Coast Experiences",
    places: [
      place(
        "Burleigh Heads",
        "Beach & Coastal Lifestyle",
        "Enjoy the beach, headland walks, cafés and restaurants at one of the Gold Coast's popular coastal destinations.",
        "Burleigh Heads, QLD 4220",
        photo.beach
      ),
      place(
        "Burleigh Head National Park",
        "Coastal Walks & Nature",
        "Explore coastal rainforest and walking tracks while enjoying views over the Gold Coast coastline.",
        "Goodwin Terrace, Burleigh Heads QLD 4220",
        photo.walk
      ),
      place(
        "SkyPoint Observation Deck",
        "Gold Coast Views",
        "Enjoy panoramic views across the Gold Coast, coastline and hinterland from one of the city's most recognisable observation points.",
        "Level 77, Q1, 9 Hamilton Avenue, Surfers Paradise QLD 4217",
        photo.skyline
      ),
      place(
        "Coolangatta Beach",
        "Beach & Ocean Activities",
        "Relax on the beautiful southern Gold Coast coastline with opportunities for swimming, surfing and coastal walks.",
        "Coolangatta, QLD 4225",
        "/images/Queensland.png"
      ),
    ],
  },
  {
    id: "rainforest-mountains",
    title: "Rainforest, Mountains & Nature",
    places: [
      place(
        "Minyon Falls",
        "Waterfall & Rainforest",
        "Discover rainforest scenery and spectacular waterfall views at Minyon Falls, a popular natural attraction in the Northern Rivers.",
        "Nightcap National Park, NSW",
        photo.falls
      ),
      place(
        "Natural Bridge",
        "Rainforest & Natural Rock Formation",
        "Explore the remarkable Natural Bridge and surrounding rainforest in Springbrook National Park.",
        "Natural Bridge, QLD 4213",
        photo.rockpool
      ),
      place(
        "Nightcap National Park",
        "World Heritage Rainforest",
        "Experience rainforest landscapes, walking trails and beautiful natural scenery in the Nightcap region.",
        "Nightcap National Park, NSW",
        photo.rainforest
      ),
      place(
        "Wollumbin Area",
        "Mountain & Valley Scenery",
        "Discover the dramatic mountain landscapes and natural beauty surrounding Wollumbin and the Tweed Valley.",
        "Wollumbin, NSW 2484",
        photo.mountain
      ),
    ],
  },
  {
    id: "tweed-coast-beaches",
    title: "Tweed Coast & Beaches",
    places: [
      place(
        "Pottsville Beach",
        "Relaxed Coastal Escape",
        "Enjoy swimming, surfing, beach walks and the relaxed atmosphere of Pottsville on the Tweed Coast.",
        "Pottsville, NSW 2489",
        photo.coast
      ),
      place(
        "Hastings Point",
        "Beach, Creek & Coastal Scenery",
        "Explore the beautiful coastline and waterways around Hastings Point for a peaceful Tweed Coast experience.",
        "Hastings Point, NSW 2489",
        photo.headland
      ),
    ],
  },
  {
    id: "wildlife-family-experiences",
    title: "Wildlife & Family Experiences",
    places: [
      place(
        "Currumbin Beach",
        "Beach Day for the Family",
        "Enjoy a relaxed day at Currumbin Beach with ocean views, swimming, surfing and coastal walks.",
        "Currumbin, QLD 4223",
        photo.beach
      ),
      place(
        "Surfers Paradise Beach",
        "Gold Coast Beach Experience",
        "Experience the iconic Gold Coast coastline with its famous beach, oceanfront attractions, restaurants and entertainment.",
        "Surfers Paradise, QLD 4217",
        "/images/GoldCoast.png"
      ),
      place(
        "Coolangatta & Tweed Heads Golf Club",
        "Golf Near Tweed Heads",
        "Enjoy a round of golf while exploring the Tweed Heads and southern Gold Coast region.",
        "Tweed Heads West, NSW 2485",
        photo.golf
      ),
      place(
        "Tweed Heads South, NSW Golf Club",
        "Golf in the Tweed Valley",
        "Enjoy a round of golf surrounded by the scenery of the Tweed Valley, conveniently located near Tweed Heads South, NSW.",
        "Byangum Road, Tweed Heads South, NSW 2484",
        photo.golf
      ),
    ],
  },
  {
    id: "gold-coast-day-trips",
    title: "Gold Coast & Day Trips",
    places: [
      place(
        "Surfers Paradise",
        "Iconic Gold Coast Experience",
        "Explore Surfers Paradise for its famous beach, shopping, restaurants, entertainment and vibrant coastal atmosphere.",
        "Surfers Paradise, QLD 4217",
        photo.skyline
      ),
      place(
        "Snapper Rocks",
        "Surfing & Coastal Views",
        "Visit Snapper Rocks near the NSW–Queensland border and enjoy the area's famous surf culture and beautiful ocean scenery.",
        "Snapper Rocks Road, Coolangatta QLD 4225",
        photo.surf
      ),
      place(
        "Kirra Beach",
        "Relax by the Gold Coast",
        "Enjoy the beautiful southern Gold Coast coastline at Kirra Beach, with swimming, surfing and scenic coastal views.",
        "Kirra Beach, QLD 4225",
        "/images/Kirra Hill Lookout.png"
      ),
      place(
        "Gold Coast Hinterland",
        "Mountains, Rainforest & Scenic Drives",
        "Take a scenic day trip into the Gold Coast Hinterland to experience rainforest, mountains, waterfalls and picturesque countryside.",
        "Gold Coast Hinterland, QLD",
        photo.hinterland
      ),
    ],
  },
];

export const activitySections = [
  {
    id: "fitness",
    title: "Fitness",
    places: [
      place(
        "Tweed Regional Aquatic Centre",
        "Fitness & Swimming",
        "Enjoy swimming and aquatic recreation during your stay. Check the centre's current visitor facilities and opening hours before visiting.",
        "Tweed Heads South, NSW 2484",
        photo.fitness
      ),
    ],
  },
  {
    id: "golf",
    title: "Golf",
    places: [
      place(
        "Tweed River Golf Club",
        "Golf Near Tweed Heads South, NSW",
        "Enjoy a round of golf in the Tweed Valley and take in the surrounding regional scenery.",
        "Tweed Heads South, NSW 2484",
        photo.golf
      ),
    ],
  },
  {
    id: "swimming",
    title: "Swimming",
    places: [
      place(
        "Kingscliff Beach",
        "Swimming & Coastal Walks",
        "Enjoy the beautiful coastline at Kingscliff with its beach, ocean views, walking areas and nearby cafés.",
        "Marine Parade, Kingscliff NSW 2487",
        photo.beach
      ),
      place(
        "Cabarita Beach",
        "Swimming & Beach Relaxation",
        "Spend the day swimming, surfing or relaxing along the beautiful Cabarita coastline.",
        "Cabarita Beach, NSW 2488",
        photo.surf
      ),
    ],
  },
  {
    id: "wellness",
    title: "Wellness",
    places: [
      place(
        "Kingscliff Spa & Wellness",
        "Relax & Rejuvenate",
        "Treat yourself to massage, beauty or wellness services around Kingscliff while exploring the Tweed Coast.",
        "Kingscliff, NSW 2487",
        photo.spa,
        "Find Spa & Wellness on Google Maps",
        "spa wellness Kingscliff NSW 2487"
      ),
      place(
        "Tweed Heads Day Spas",
        "Wellness Near Tweed Heads",
        "Discover massage, beauty and wellness services around Tweed Heads for a relaxing addition to your stay.",
        "Tweed Heads, NSW 2485",
        photo.spa,
        "Find Day Spas on Google Maps",
        "day spas Tweed Heads NSW 2485"
      ),
    ],
  },
];

export const popularPlaces = [
  "Tweed Heads South, NSW Town Centre",
  "Tweed Regional Gallery & Margaret Olley Art Centre",
  "Tweed River",
  "M-Arts Precinct",
  "Tropical Fruit World",
  "Kingscliff Beach",
  "Cabarita Beach",
  "Fingal Head",
  "Hastings Point",
  "Tweed Heads",
  "Point Danger",
  "Currumbin Wildlife Sanctuary",
  "Nightcap National Park",
];
